import { createFileRoute, Outlet } from '@tanstack/react-router'

import { ResourcesLayout } from '../components/templates/resources-layout.tsx'

export const Route = createFileRoute('/resources')({
  component: ResourcesRoute,
})

function ResourcesRoute() {
  return (
    <ResourcesLayout>
      <Outlet />
    </ResourcesLayout>
  )
}
